import Bugsnag from '@bugsnag/js';

Bugsnag.start({
    apiKey: 'c980b51e5ba9e31b9ef8708e3e4d2580',
    releaseStage: process.env.NODE_ENV,
    enabledReleaseStages: ['production', 'staging']
});

export default Bugsnag;
